import type { OrderStatus } from '../types';

/** Target statuses allowed via `PATCH /admin/orders/:id/status` from the current wire status. */
export type FulfilmentPatchTarget =
  | 'PICKING'
  | 'PARTIALLY_FULFILLED'
  | 'PACKED'
  | 'DISPATCHED'
  | 'DELIVERED';

const TRANSITIONS: Partial<Record<OrderStatus, readonly FulfilmentPatchTarget[]>> = {
  CONFIRMED: ['PICKING'],
  PICKING: ['PACKED', 'PARTIALLY_FULFILLED'],
  PARTIALLY_FULFILLED: ['PACKED'],
  PACKED: ['DISPATCHED'],
  DISPATCHED: ['DELIVERED'],
};

export function getAllowedFulfilmentStatusTargets(
  current: OrderStatus,
): readonly FulfilmentPatchTarget[] {
  return TRANSITIONS[current] ?? [];
}

export function canPatchFulfilmentStatus(current: OrderStatus): boolean {
  return getAllowedFulfilmentStatusTargets(current).length > 0;
}
